export const csrComponentNameAttribute = 'csr-component-name';
